<template>
  <modal :modal-key="'pending_challenged_request'" :class-style="'modal--welcomeback modal--zero-balance'"
         :header-style="'request'"
         :body-style="'pending_content'"
         :footer-style="'footer_buttons'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_pending_chall_req_your_challenge_invitation }}</h1>
      <div class="request_user">
        <img :src=challengeInfo.challengingAvatar alt="">
        <div class="blocking_user">
          <div class="little_star">
            <div class="block" @click.prevent="blockUser()">
              <input id="block-checkbox" class="block-checkbox" type="checkbox">
              <label for="block-checkbox" class="block-label"><span class="block-label-text"></span></label>
              <svg class="unblock-star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72.22 72.21">
                <path
                  d="M65.24,19.48l3.54-3.54a2.8,2.8,0,1,0-4-4l-58,58a2.8,2.8,0,0,0,4,4l3.54-3.54A36.14,36.14,0,0,0,65.24,19.48ZM59.38,64.57a30.54,30.54,0,0,1-41.11,1.89l40.6-40.61,2.4-2.4a30.56,30.56,0,0,1-1.89,41.12Z"
                  transform="translate(-1.7 -6.89)"/>
                <path
                  d="M8.79,62.16a2.71,2.71,0,0,0,1.37-.37A2.79,2.79,0,0,0,11.22,58,30.5,30.5,0,0,1,52.79,16.41a2.8,2.8,0,1,0,2.75-4.87A36.1,36.1,0,0,0,6.35,60.74,2.81,2.81,0,0,0,8.79,62.16Z"
                  transform="translate(-1.7 -6.89)"/>
              </svg>
            </div>
          </div>
        </div>
        <span class="name">{{ challengeInfo.challengingUsername }}</span>
        <span
          class="level">{{ getTranslations.home_pending_chall_req_level }} {{ challengeInfo.challengingLevel }}</span>
      </div>
    </template>
    <template slot="body">
      <p>{{ getTranslations.home_pending_chall_req_hi }} {{ userDetails.username }} {{
        getTranslations.home_pending_chall_req_ready_to_play }}</p>
      <div class="stickers-cell"><img class="pinicon" :src="'static/images/chat/chat_icon_' + challengeInfo.challengingStickerIcon +'.svg'" alt=""></div>
    </template>
    <template slot="waiting">
      <div class="waiting_content">
        <p>{{ getTranslations.home_pending_chall_req_opponent_is_waiting }}</p>
        <div id="timer"></div>
      </div>
    </template>
    <template slot="footer">
      <a class="btn2  btn2--outline btn2--small" @click.prevent="responseToChallengeMethod(false)" style="cursor:pointer">{{
        getTranslations.home_pending_chall_req_decline }}</a>
      <a class="btn2 btn2--small btn2--std" @click.prevent="responseToChallengeMethod(true)" style="cursor:pointer">{{
        getTranslations.home_pending_chall_req_accept }}</a>
    </template>
  </modal>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import PendingTimeRematch from '@/common/jQueryMixin';

export default {
  // modal_pending_challenged_request
  name: 'pending-challenged-request',
  mixins: [
    PendingTimeRematch,
  ],
  components: {
    Modal,
  },
  beforeDestroy() {
    this.onTimesUp();
    this.storeModalForChallenge(null);
  },
  mounted() {
    this.$nextTick(() => {
      this.initiateTimer(this.timeToAcceptChallenge / 1000, 0, this.challengeInfo.opponentIsBot);
      // fix animation on window resize
      // eslint-disable-next-line
      // $(window).resize(() => this.initiateTimer(this.timeToAcceptChallenge / 1000, 0, this.challengeInfo.opponentIsBot));
    });
  },
  methods: {
    ...mapActions('users', [
      'markBlockedUser',
    ]),
    ...mapActions('game', [
      'responseToChallenge',
    ]),
    ...mapMutations('game', [
      'setToDefaultChallengeInfo',
    ]),
    ...mapMutations('common', [
      'storeModalForChallenge',
      'unregisterModal',
    ]),
    ...mapMutations('users', [
      'refreshSelectedUser',
    ]),
    blockUser() {
      this.markBlockedUser(this.challengeInfo.challengingUsername);
      this.responseToChallengeMethod(false);
    },
    responseToChallengeMethod(isAccepted) {
      const payload = {
        opponentUsername: this.challengeInfo.challengingUsername,
        challengeAccepted: isAccepted,
      };
      this.responseToChallenge(payload).then(() => {
        this.storeModalForChallenge(null);
        this.setToDefaultChallengeInfo();
      });
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('common', [
      'userDetails',
      'timeToAcceptChallenge',
    ]),
    ...mapState('game', [
      'challengeInfo',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/challenge/PendingChallengedRequest.vue